export default __webpack_public_path__ + "static/media/complete_main.77810229.png";